export default __webpack_public_path__ + "static/media/sb.5c3922e0.PNG";